'use client';

import ImageAdaptive from '@/components/ImageAdaptive';

export interface LabScoreCountProps {
    count?: number;
    onClick?: () => void;
}

export default function LabScoreCount({ count, onClick }: LabScoreCountProps) {
    const safeCount = typeof count === 'number' && !isNaN(count) ? count : 0;
    return (
        <div className="flex items-center">
            <div>
                <ImageAdaptive
                    src="/images/common/count-score.svg"
                    baseWidth={50}
                    breakpoints={{ md: 50 }}
                    className="-my-2"
                    onClick={onClick}
                />
            </div>
            <div className="ml-1 font-cantarell font-bold text-sm text-color-base">{safeCount}</div>
        </div>
    );
}
